export var NodeOrigins;
(function (NodeOrigins) {
    NodeOrigins["TOPLEFT"] = "TOPLEFT";
    NodeOrigins["TOPCENTER"] = "TOPCENTER";
    NodeOrigins["TOPRIGHT"] = "TOPRIGHT";
    NodeOrigins["MIDDLELEFT"] = "MIDDLELEFT";
    NodeOrigins["MIDDLECENTER"] = "MIDDLECENTER";
    NodeOrigins["MIDDLERIGHT"] = "MIDDLERIGHT";
    NodeOrigins["BOTTOMLEFT"] = "BOTTOMLEFT";
    NodeOrigins["BOTTOMCENTER"] = "BOTTOMCENTER";
    NodeOrigins["BOTTOMRIGHT"] = "BOTTOMRIGHT";
})(NodeOrigins || (NodeOrigins = {}));
